import { Cart, TWindow } from '../../../../types';

export type AddToCart = (id: Number) => Promise<Cart>;
const _window = window as TWindow;

export const addFreeSampleToCart: AddToCart = async id => {
  try {
    const payload = {
      id: id,
      quantity: 1,
    };
    const addToCart = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    if (!addToCart.ok) throw new Error(JSON.stringify(addToCart.json()));
    _window.ajaxCartInit();
    let cartButton: HTMLElement = document.getElementsByClassName(
      'ajax-cart',
    )[0] as HTMLElement;
    cartButton.click();
    return await addToCart.json();
  } catch (error) {
    console.log('error?', error);
    return error;
  }
};
